module.exports = __webpack_public_path__ + "media/images/ohap_calendar_right_arrow-233b8439a0ad1c8e3c72cc09b072a098.png";